import { T } from "../i18n"

export const bikeGif = require("../components/images/bike.webp")
export const helmetGif = require("../components/images/elmet.gif")
export const phoneGif = require('../components/images/phone.gif')

export const extraDevice = [
  {
    id: -1,
    name: T('eq_extra_device_name'),
    description: T('eq_extra_device_desc'),
    typeIcon: phoneGif,
    price: 5,
    confirmationRequired: false,
    pricePerDay: false
  }
]

// deprecato non si usa più, leggo da admin
export const catalogue = [
  {
    id: 2,
    name: T('eq_bike_name'),
    description: T('eq_bike_desc'),
    typeIcon: bikeGif,
    price: 50,
    confirmationRequired: true,
    requireTallInfos: true,
    pricePerDay: true
  },
  {
    id: 4,
    name: T('eq_elmet_name'),
    description: T('eq_elmet_desc'),
    typeIcon: helmetGif,
    price: 5,
    confirmationRequired: true,
    pricePerDay: true
  }
]